import React, { useEffect } from 'react';
import { Container, Row, Col, ListGroup, Card} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import pdf from './Assets/AreNaveenKumar.pdf'

const Resume = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
 <div className="main " style={{backgroundColor: '#f5f6ff' }}>
 <Container fluid className="d-flex justify-content-center" style={{ padding: '20px'}}>
 <Card style={{ width: '100%', maxWidth: '800px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
   {/* Header Section */}
   <Row className="mb-3">
     <Col>
       <h1>Are Naveen Kumar</h1>
       <h5>Full Stack Developer</h5>
       <p>
         Contact: +91 8096858075 | <a href="mailto:naveenkumarare66@gmail.com">naveenkumarare66@gmail.com</a><br />
         Location: Hyderabad, Telangana, India
         <br />
         <a href="https://www.linkedin.com/in/arenaveenkumar/" target="_blank" rel="noopener noreferrer" className="g-2 btn btn-outline-primary">LinkedIn <i className="fa-solid fa-arrow-up-right-from-square"></i></a>
         <a href="https://github.com/arenaveenkumar" target="_blank" rel="noopener noreferrer" className="m-2 btn btn-outline-dark"> GitHub <i className="fa-solid fa-arrow-up-right-from-square"></i></a>
       </p>
     </Col>
   </Row>
   <hr />

   {/* About Me */}
   <Row className="mb-3">
     <Col>
       <h3>About Me</h3>
       <p>
         Hi! I'm Naveen, an engineering graduate with a passion for learning and exploring new things. I aim to become a Business Analyst and enjoy problem-solving. I am self-motivated and excited to embark on a successful career journey.
       </p>
     </Col>
   </Row>
   <hr />

   {/* Education */}
   <Row className="mb-3">
     <Col>
       <h3>Education</h3>
       <ListGroup variant="flush">
         <ListGroup.Item>
           <strong>Indur Institute of Engineering & Technology</strong>
           <br />B.Tech (Electrical & Electronics Engineering), 2023
           <br />CGPA: 7.11
         </ListGroup.Item>
         <ListGroup.Item>
           <strong>Indur Institute of Engineering & Technology</strong>
           <br />Diploma (Electrical & Electronics Engineering), 2020
           <br />Percentage: 74.13%
         </ListGroup.Item>
         <ListGroup.Item>
           <strong>Matriculation</strong>, 2017
           <br />CGPA: 7.8
         </ListGroup.Item>
       </ListGroup>
     </Col>
   </Row>
   <hr />

   {/* Professional Experience */}
   <Row className="mb-3">
     <Col>
       <h3>Professional Experience</h3>
       <ListGroup variant="flush">
         <ListGroup.Item>
           <strong>Systemtron</strong>
           <br />Web Development Internship
           <br />Jan 2024 - Feb 2024
         </ListGroup.Item>
       </ListGroup>
     </Col>
   </Row>
   <hr />

   {/* Skills */}
   <Row className="mb-3">
     <Col>
       <h3>Skills</h3>
       <ListGroup variant="flush">
         {/* Programming */}
         <ListGroup.Item>
           <strong>Programming:</strong><br />
           Java
         </ListGroup.Item>

         {/* Databases */}
         <ListGroup.Item>
           <strong>Databases:</strong><br />
           MySQL
         </ListGroup.Item>

         {/* Web Development */}
         <ListGroup.Item>
           <strong>Web Development:</strong><br />
           HTML, CSS, JavaScript, Node.js, React, PHP
         </ListGroup.Item>

         {/* Tools/Platforms */}
         <ListGroup.Item>
           <strong>Tools/Platforms:</strong><br />
           VS Code, GitHub, Eclipse
         </ListGroup.Item>

         {/* Operating Systems */}
         <ListGroup.Item>
           <strong>Operating Systems:</strong><br />
           Windows XP, 7, 10, 11;<br /> Linux, Ubuntu
         </ListGroup.Item>
       </ListGroup>
     </Col>
   </Row>
   <hr />

   {/* Languages */}
   <Row>
     {/* Languages */}
     <Col md={6}>
       <h3>Languages</h3>
       <ListGroup variant="flush">
         <ListGroup.Item>
           English, Telugu, Hindi
         </ListGroup.Item>
       </ListGroup>
     </Col>
   </Row>
   <hr />

   {/* Certifications */}
   <Row className="mb-3">
     <Col>
       <h3>Certifications</h3>
       <ListGroup variant="flush">
         <ListGroup.Item>
           <strong>TCS iON Career Edge - Young Professional</strong>
           <br />11/2022 - 07/2023
         </ListGroup.Item>
         <ListGroup.Item>
           <strong>Front-End Development - HTML from GREAT LEARNING</strong>
           <br />08/2023
         </ListGroup.Item>
         <ListGroup.Item>
           <strong>Course Completion Certificate in "SQL" by FRONTLINESMEDIA Edu. Tech (FLM)</strong>
         </ListGroup.Item>
       </ListGroup>
     </Col>
   </Row>
 </Card>
</Container>
{/* Download Section */}
<div className="download mb-5" style={{ textAlign: 'center', marginTop: '20px' }}>
<a href={pdf} download="ARE NAVEEN KUMAR.pdf" className="btn btn-outline-success p-2 fw-bold ">Download Resume <i class="fa-solid fa-file-arrow-down fs-5"></i></a>
</div>


<div className="footer1 bg-secondary text-white p-3">
<Container className="px-0">
  <Row className="justify-content-center align-items-center">
    <Col xs={12} sm={4} className="mb-3 mb-sm-0 text-center text-sm-start">
      <h6>Designed & Developed by <a href="https://www.linkedin.com/in/arenaveenkumar" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><strong className='text-warning'>ARE NAVEEN KUMAR</strong></a></h6>
    </Col>
    <Col xs={12} sm={4} className="text-center mb-4 mb-sm-0">
      <h6 className="mb-0"><i className="fa-regular fa-copyright "></i> Copyright-2024</h6>
    </Col>
    <Col xs={12} sm={4} className="d-flex justify-content-center justify-content-sm-end">
      <a href="https://www.linkedin.com/in/arenaveenkumar/" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in fs-4"></i></a>
      <a href="https://github.com/arenaveenkumar" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github fs-4"></i></a>
      <a href="https://www.instagram.com/arenaveenkumar_" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram fs-4"></i></a>
      <a href="https://wa.me/918096858075" className="text-white" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp fs-4"></i></a>

    </Col>
  </Row>
</Container>
</div>
 
 </div>
  );
};

export default Resume;
